/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_SponsoredInputs */

const en_blog_sponsored = /** @type {(inputs: Blog_SponsoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsored`)
};

/**
* | output |
* | --- |
* | "Sponsored" |
*
* @param {Blog_SponsoredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const blog_sponsored = /** @type {((inputs?: Blog_SponsoredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_SponsoredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_blog_sponsored(inputs)
});
export { blog_sponsored as "blog.sponsored" }